export default __webpack_public_path__ + "media/images/channel_org-503c0bd5506d1dc4ce791a2b21a5bb62.svg";